import { useContext } from 'react';
import TenantContext from 'contexts/TenantContext';
import { TenantContextType } from 'types/tenant';

/**
 * @returns
 * @throws
 */
const useTenant = (): TenantContextType => {
  const context = useContext(TenantContext);

  if (!context) {
    throw new Error('useTenant deve ser usado dentro de um TenantProvider');
  }

  return context;
};

export default useTenant;
